module.exports = __webpack_public_path__ + "img/api.8ee5074.svg";